import { ICreateCategoriaAssistenciaUseCase } from "../../../presentation/useCases/create/create_categoria_assistencia_use_case";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * CreateCategoriaAssistenciaUseCase
 */

export class CreateCategoriaAssistenciaUseCase implements ICreateCategoriaAssistenciaUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async createCategoriaAssistencia(
    status: number,
    categoria: string,
  ): Promise<void> {
    await this.repository.createCategoriaAssistencia(
      status,
      categoria,
    );
  }
}
